import * as React from 'react';

export const accordionSchemaData = [
  {
    title: '13 видеоуроков',
    description:
      <ul>
        <li>Урок 1. Введение</li>
        <li>Урок 2. Измерение природного темпа деятельности</li>
        <li>Урок 3. Техника чтения и измерение</li>
        <li>Урок 4. Внимание</li>
        <li>Урок 5. Память</li>
        <li>Урок 6. Развитие восприятия, бокового зрения</li>
        <li>Урок 7. Мышление</li>
        <li>Урок 8. Артикуляция и дыхательная гимнастика</li>
        <li>Урок 9. Методики скорочтения</li>
        <li>Урок 10. Понимание и запоминание</li>
        <li>Урок 11. Речь</li>
        <li>Урок 12. Интерес к чтению</li>
        <li>Урок 13. Заключение</li>
      </ul>
  }
];
